import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdministrarObrasControlComponent } from '../modules/administracion/components/administrar-obras-control/administrar-obras-control.component';
import { DashboardadminComponent } from './dashboardadmin/dashboardadmin.component';
import { CapturapanelprincipalComponent } from './pages/capturapanelprincipal/capturapanelprincipal.component';

const routes: Routes = [
  { path: '', component: DashboardadminComponent, children: [
    { path: 'admon-obras-control', component: AdministrarObrasControlComponent },
  ]},


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardadminRoutingModule {}
